export default __webpack_public_path__ + "static/audio-cardio-3-aa-f56ace5e5c7bc6482cea335a3597b894.webp";